import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { listCountries } from "./countries.thunk";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

const useCountries = () => {
  const dispatch = useAppDispatch();
  const {
    data: countries,
    error: countriesError,
    status: countriesStatus,
  } = useAppSelector((store) => store.countries);

  const getCountries = useCallback(() => {
    dispatch(listCountries());
  }, [dispatch]);

  const forceRefresh = useCallback(() => {
    dispatch(listCountries());
  }, [dispatch]);

  return {
    countries,
    countriesError,
    countriesStatus,
    isIdle: isIdle(countriesStatus),
    isLoading: isLoading(countriesStatus),
    isSuccess: isSuccess(countriesStatus),
    isError: isError(countriesStatus),
    getCountries,
    forceRefresh,
  };
};

export default useCountries;
